import { Component } from 'react';

class Privado extends Component {
    render() {
    }
}

export default Privado;